import { IAutoAuthFailureCause, IReAuthState } from "@/store/slices/app/types"

export interface IAutoAuthInput {
  isTMA: boolean
  hasSession: boolean
  reAuthKind: IReAuthState["kind"]
  initData: string
}

export type IAutoAuthDecision =
  | { action: "none" }
  | { action: "fail"; cause: "no_launch_data" }
  | { action: "login"; initData: string }

export const decideAutoAuth = (input: IAutoAuthInput): IAutoAuthDecision => {
  if (!input.isTMA || input.hasSession || input.reAuthKind !== "idle") {
    return { action: "none" }
  }

  if (input.initData === "") {
    return { action: "fail", cause: "no_launch_data" }
  }

  return { action: "login", initData: input.initData }
}

export const classifyAutoAuthFailure = (
  status?: number
): Exclude<IAutoAuthFailureCause, "no_launch_data"> =>
  status === 401 ? "rejected" : "transient"
